import { Component, input, computed } from '@angular/core';
import { CommonModule, NgStyle } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { User } from 'quest-atlas-angular-components';

@Component({
  selector: 'app-user-list-item',
  imports: [CommonModule, NgStyle, TranslocoModule],
  templateUrl: './user-list-item.component.html',
  styleUrl: './user-list-item.component.scss'
})
export class UserListItemComponent {
  user = input.required<User>();

  nameFirstLetter = computed(() => {
    return this.user().username?.charAt(0).toUpperCase() || '?';
  });
}

